// import React, { useState, useEffect } from 'react';
// import {
//   Layout,
//   Menu,
//   Card,
//   Table,
//   Button,
//   Modal,
//   Form,
//   Input,
//   InputNumber,
//   Select,
//   Space,
//   Popconfirm,
//   message,
//   Row,
//   Col,
//   Statistic,
//   Tag,
//   Tabs,
//   DatePicker,
//   Upload,
//   Switch,
//   Divider,
//   Badge,
//   Typography,
//   Drawer,
//   List,
//   Avatar,
//   Grid
// } from 'antd';
// import {
//   ShoppingCartOutlined,
//   AppstoreOutlined,
//   TagsOutlined,
//   GiftOutlined,
//   DashboardOutlined,
//   PlusOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   EyeOutlined,
//   UploadOutlined,
//   DollarOutlined,
//   ShoppingOutlined,
//   UserOutlined,
//   BarChartOutlined,
//   PhoneOutlined,
//   MailOutlined,
//   CalendarOutlined,
//   HomeOutlined,
//   SearchOutlined,
//   ClearOutlined,
//   FilterOutlined
// } from '@ant-design/icons';
// import { orderService } from '../services';
// import { useApiEnhanced } from '../hooks/useApiEnhanced';
// import { toast } from 'react-toastify';

// const { Header, Sider, Content } = Layout;
// const { Option } = Select;
// const { TextArea } = Input;
// const { Title, Text } = Typography;
// const { TabPane } = Tabs;
// const { useBreakpoint } = Grid;

// const OrdersSection = () => {
//   const screens = useBreakpoint();
//   const isMobile = !screens.md;
//   const isTablet = screens.md && !screens.lg;

//   // Search filters state
//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilters, setStatusFilters] = useState({
//     paymentStatus: '',
//     shippingStatus: ''
//   });
//   const [filteredOrders, setFilteredOrders] = useState([]);

//   const {
//     data: orders,
//     loading: ordersLoading,
//     execute: refetchOrder
//   } = useApiEnhanced(
//     () => orderService.getOrders({page: 1, limit: 100}),
//     {immediate: true}
//   );

//   const {
//     loading: updateLoading,
//     execute: updateOrder
//   } = useApiEnhanced(
//     (id,data) => orderService.updateOrder(id,data),
//     {immediate: false}
//   );

//   console.log(orders, "ordersList");

//   const [editDrawerVisible, setEditDrawerVisible] = useState(false);
//   const [viewModalVisible, setViewModalVisible] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [form] = Form.useForm();

//   // Filter orders based on search criteria
//   useEffect(() => {
//     if (!orders?.data) {
//       setFilteredOrders([]);
//       return;
//     }

//     let filtered = orders.data.filter(order => {
//       const customerName = order.customer?.name?.toLowerCase() || '';
//       const email = order.customer?.email?.toLowerCase() || '';
//       const orderId = order.orderId?.toLowerCase() || '';
//       const searchLower = searchTerm.toLowerCase();

//       // Check if search term matches any of the fields
//       const matchesSearch = searchTerm === '' ||
//         customerName.includes(searchLower) ||
//         email.includes(searchLower) ||
//         orderId.includes(searchLower);

//       // Check status filters
//       const matchesPaymentStatus = statusFilters.paymentStatus === '' ||
//         order.paymentStatus === statusFilters.paymentStatus;
//       const matchesShippingStatus = statusFilters.shippingStatus === '' ||
//         order.shippingStatus === statusFilters.shippingStatus;

//       return matchesSearch && matchesPaymentStatus && matchesShippingStatus;
//     });

//     setFilteredOrders(filtered);
//   }, [orders?.data, searchTerm, statusFilters]);

//   // Handle search filter changes
//   const handleSearchChange = (value) => {
//     setSearchTerm(value);
//   };

//   const handleStatusFilterChange = (key, value) => {
//     setStatusFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   // Clear all filters
//   const clearAllFilters = () => {
//     setSearchTerm('');
//     setStatusFilters({
//       paymentStatus: '',
//       shippingStatus: ''
//     });
//   };

//   // Check if any filters are active
//   const hasActiveFilters = searchTerm !== '' || Object.values(statusFilters).some(filter => filter !== '');

//   // Desktop/Tablet columns
//   const getColumns = () => {
//     const baseColumns = [
//       {
//         title: 'Order ID',
//         dataIndex: 'orderId',
//         key: 'orderId',
//         width: 120,
//         fixed: 'left'
//       },
//       {
//         title: 'Customer',
//         dataIndex: ['customer', 'name'],
//         key: 'customer',
//         width: 120
//       },
//       {
//         title: 'Amount',
//         dataIndex: 'finalAmount',
//         key: 'amount',
//         width: 100,
//         render: (amount) => `AED ${amount?.toFixed(2) || '0.00'}`
//       },
//       {
//         title: 'Date',
//         dataIndex: 'createdAt',
//         key: 'date',
//         width: 120,
//         render: (date) => new Date(date).toLocaleDateString('en-US', {
//           month: 'short',
//           day: 'numeric'
//         })
//       },
//       {
//         title: 'Actions',
//         key: 'actions',
//         width: 120,
//         fixed: 'right',
//         render: (_, record) => (
//           <Space size="small">
//             <Button
//               icon={<EyeOutlined />}
//               onClick={() => handleView(record)}
//               size="small"
//               type="text"
//             />
//             <Button
//               icon={<EditOutlined />}
//               onClick={() => handleEdit(record)}
//               size="small"
//               type="text"
//             />
//           </Space>
//         ),
//       },
//     ];

//     // Add more columns for larger screens
//     if (!isMobile) {
//       baseColumns.splice(2, 0, {
//         title: 'Email',
//         dataIndex: ['customer', 'email'],
//         key: 'email',
//         width: 200
//       });

//       baseColumns.splice(3, 0, {
//         title: 'Phone',
//         dataIndex: ['customer', 'phone'],
//         key: 'phone',
//         width: 120
//       });

//       if (!isTablet) {
//         baseColumns.splice(5, 0, {
//           title: 'Payment Method',
//           dataIndex: 'paymentMethod',
//           key: 'paymentMethod',
//           width: 120
//         });

//         baseColumns.splice(7, 0, {
//           title: 'Payment Status',
//           dataIndex: 'paymentStatus',
//           key: 'paymentStatus',
//           width: 120,
//           render: (status) => {
//             const colors = {
//               Pending: 'orange',
//               Paid: 'green',
//               Failed: 'red',
//               Refunded: 'purple'
//             };
//             return <Tag color={colors[status]}>{status}</Tag>;
//           }
//         });

//         baseColumns.splice(8, 0, {
//           title: 'Shipping Status',
//           dataIndex: 'shippingStatus',
//           key: 'shippingStatus',
//           width: 120,
//           render: (status) => {
//             const colors = {
//               'Not Shipped': 'default',
//               'Preparing': 'orange',
//               'Shipped': 'blue',
//               'In Transit': 'cyan',
//               'Delivered': 'green'
//             };
//             return <Tag color={colors[status]}>{status}</Tag>;
//           }
//         });
//       }
//     }

//     return baseColumns;
//   };

//   // Mobile card view
//   const OrderCard = ({ order }) => (
//     <Card
//       size="small"
//       style={{ marginBottom: 12 }}
//       actions={[
//         <Button
//           type="text"
//           icon={<EyeOutlined />}
//           onClick={() => handleView(order)}
//           size="small"
//         >
//           View
//         </Button>,
//         <Button
//           type="text"
//           icon={<EditOutlined />}
//           onClick={() => handleEdit(order)}
//           size="small"
//         >
//           Edit
//         </Button>
//       ]}
//     >
//       <div style={{ marginBottom: 8 }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
//           <Text strong style={{ fontSize: 16 }}>{order.orderId}</Text>
//           <Text strong style={{ color: '#1890ff', fontSize: 16 }}>
//             AED {order.finalAmount?.toFixed(2) || '0.00'}
//           </Text>
//         </div>

//         <div style={{ marginBottom: 6 }}>
//           <UserOutlined style={{ marginRight: 6, color: '#666' }} />
//           <Text>{order.customer?.name}</Text>
//         </div>

//         <div style={{ marginBottom: 6 }}>
//           <MailOutlined style={{ marginRight: 6, color: '#666' }} />
//           <Text style={{ fontSize: 12 }}>{order.customer?.email}</Text>
//         </div>

//         <div style={{ marginBottom: 6 }}>
//           <PhoneOutlined style={{ marginRight: 6, color: '#666' }} />
//           <Text>{order.customer?.phone}</Text>
//         </div>

//         <div style={{ marginBottom: 8 }}>
//           <CalendarOutlined style={{ marginRight: 6, color: '#666' }} />
//           <Text style={{ fontSize: 12 }}>
//             {new Date(order.createdAt).toLocaleDateString('en-US', {
//               year: 'numeric',
//               month: 'short',
//               day: 'numeric'
//             })}
//           </Text>
//         </div>

//         <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
//           <Tag color={getStatusColor(order.status)}>{order.status}</Tag>
//           <Tag color={getPaymentStatusColor(order.paymentStatus)}>{order.paymentStatus}</Tag>
//           <Tag color={getShippingStatusColor(order.shippingStatus)}>{order.shippingStatus}</Tag>
//         </div>
//       </div>
//     </Card>
//   );

//   const getStatusColor = (status) => {
//     const colors = {
//       Pending: 'orange',
//       Processing: 'blue',
//       Shipped: 'cyan',
//       Delivered: 'green',
//       Cancelled: 'red',
//       Refunded: 'purple'
//     };
//     return colors[status] || 'default';
//   };

//   const getPaymentStatusColor = (status) => {
//     const colors = {
//       Pending: 'orange',
//       Paid: 'green',
//       Failed: 'red',
//       Refunded: 'purple'
//     };
//     return colors[status] || 'default';
//   };

//   const getShippingStatusColor = (status) => {
//     const colors = {
//       'Not Shipped': 'default',
//       'Preparing': 'orange',
//       'Shipped': 'blue',
//       'In Transit': 'cyan',
//       'Delivered': 'green'
//     };
//     return colors[status] || 'default';
//   };

//   const handleView = (order) => {
//     setSelectedOrder(order);
//     setViewModalVisible(true);
//   };

//   const handleEdit = (order) => {
//     setSelectedOrder(order);
//     form.setFieldsValue({
//       status: order.status,
//       paymentStatus: order.paymentStatus,
//       shippingStatus: order.shippingStatus,
//       trackingNumber: order.trackingNumber,
//       shippingAddress: `${order.shippingAddress?.address || ''}, ${order.shippingAddress?.city || ''}, ${order.shippingAddress?.country || ''}`
//     });
//     setEditDrawerVisible(true);
//   };

//   const handleUpdateOrder = async (values) => {
//     try {
//       let res = await updateOrder(selectedOrder?._id, values);
//       if (!res?.success) return toast.error(res?.message || 'something went wrong!');
//       toast.success(res?.message || "updated successfully!");
//       refetchOrder();
//       setEditDrawerVisible(false);
//       form.resetFields();
//       setSelectedOrder(null);
//     } catch (error) {
//       return toast.error('Something went wrong!');
//     }
//   };

//   return (
//     <div style={{ padding: isMobile ? '12px' : '24px' }}>
//       <Title level={isMobile ? 4 : 3} style={{ marginBottom: 16 }}>
//         Orders Management
//       </Title>

//       {/* Search and Filters */}
//       <Card
//         size="small"
//         style={{ marginBottom: 16 }}
//         title={
//           <Space>
//             <FilterOutlined />
//             <Text strong>Search & Filters</Text>
//             {hasActiveFilters && (
//               <Badge count={1} />
//             )}
//           </Space>
//         }
//         extra={
//           hasActiveFilters && (
//             <Button
//               size="small"
//               icon={<ClearOutlined />}
//               onClick={clearAllFilters}
//               type="text"
//             >
//               Clear All
//             </Button>
//           )
//         }
//       >
//         <Row gutter={[16, 16]}>
//           <Col xs={24} sm={12} md={12} lg={12}>
//             <Input
//               placeholder="Search by Customer Name, Email, or Order ID"
//               prefix={<SearchOutlined />}
//               value={searchTerm}
//               onChange={(e) => handleSearchChange(e.target.value)}
//               allowClear
//               size="default"
//             />
//           </Col>

//           {/* <Col xs={24} sm={12} md={6} lg={6}>
//             <Select
//               placeholder="Payment Status"
//               value={statusFilters.paymentStatus}
//               onChange={(value) => handleStatusFilterChange('paymentStatus', value)}
//               allowClear
//               style={{ width: '100%' }}
//               size="default"
//             >
//               <Option value="Pending">Pending</Option>
//               <Option value="Paid">Paid</Option>
//               <Option value="Failed">Failed</Option>
//               <Option value="Refunded">Refunded</Option>
//             </Select>
//           </Col> */}

//           <Col xs={24} sm={12} md={6} lg={6}>
//             <Select
//               placeholder="Shipping Status"
//               value={statusFilters.shippingStatus}
//               onChange={(value) => handleStatusFilterChange('shippingStatus', value)}
//               allowClear
//               style={{ width: '100%' }}
//               size="default"
//             >
//               <Option value="Not Shipped">Not Shipped</Option>
//               <Option value="Preparing">Preparing</Option>
//               <Option value="Shipped">Shipped</Option>
//               <Option value="In Transit">In Transit</Option>
//               <Option value="Delivered">Delivered</Option>
//             </Select>
//           </Col>
//         </Row>

//         {hasActiveFilters && (
//           <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #f0f0f0' }}>
//             <Text type="secondary" style={{ fontSize: 12 }}>
//               Showing {filteredOrders.length} of {orders?.data?.length || 0} orders
//               {searchTerm && (
//                 <span> • Searching for: "{searchTerm}"</span>
//               )}
//             </Text>
//           </div>
//         )}
//       </Card>

//       {isMobile ? (
//         // Mobile view - Card layout
//         <div>
//           {ordersLoading ? (
//             <div style={{ textAlign: 'center', padding: 20 }}>
//               <Text>Loading orders...</Text>
//             </div>
//           ) : filteredOrders.length === 0 ? (
//             <Card style={{ textAlign: 'center', padding: 20 }}>
//               <Text type="secondary">
//                 {hasActiveFilters ? 'No orders match your search criteria' : 'No orders found'}
//               </Text>
//             </Card>
//           ) : (
//             filteredOrders.map((order, index) => (
//               <OrderCard key={order._id || index} order={order} />
//             ))
//           )}
//         </div>
//       ) : (
//         // Desktop/Tablet view - Table layout
//         <Table
//           columns={getColumns()}
//           dataSource={filteredOrders}
//           loading={ordersLoading}
//           scroll={{ x: 'max-content' }}
//           pagination={{
//             responsive: true,
//             showSizeChanger: true,
//             showQuickJumper: !isTablet,
//             showTotal: (total, range) =>
//               `${range[0]}-${range[1]} of ${total} orders${hasActiveFilters ? ' (filtered)' : ''}`,
//             pageSizeOptions: ['10', '20', '50', '100']
//           }}
//           size={isTablet ? 'small' : 'middle'}
//           locale={{
//             emptyText: hasActiveFilters ? 'No orders match your search criteria' : 'No orders found'
//           }}
//         />
//       )}

//       {/* View Order Modal */}
//       <Modal
//         title={`Order Details - ${selectedOrder?.orderId}`}
//         visible={viewModalVisible}
//         onCancel={() => {
//           setViewModalVisible(false);
//           setSelectedOrder(null);
//         }}
//         footer={[
//           <Button key="close" onClick={() => {
//             setViewModalVisible(false);
//             setSelectedOrder(null);
//           }}>
//             Close
//           </Button>
//         ]}
//         width={isMobile ? '95%' : 700}
//         style={isMobile ? { top: 20 } : {}}
//       >
//         {selectedOrder && (
//           <div>
//             <Row gutter={[16, 16]}>
//               <Col xs={24} sm={12}>
//                 <Text strong>Customer:</Text> {selectedOrder.customer?.name}
//               </Col>
//               <Col xs={24} sm={12}>
//                 <Text strong>Email:</Text> {selectedOrder.customer?.email}
//               </Col>
//             </Row>

//             <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
//               <Col xs={24} sm={12}>
//                 <Text strong>Phone:</Text> {selectedOrder.customer?.phone}
//               </Col>
//               <Col xs={24} sm={12}>
//                 <Text strong>Payment Method:</Text> {selectedOrder.paymentMethod}
//               </Col>
//             </Row>

//             <Divider />

//             <Row gutter={[16, 16]}>
//               <Col xs={24} sm={12}>
//                 <Text strong>Order Date:</Text>{' '}
//                 {new Date(selectedOrder.createdAt).toLocaleDateString()}
//               </Col>
//               <Col xs={24} sm={12}>
//                 <Text strong>Total Amount:</Text> AED {selectedOrder.finalAmount?.toFixed(2)}
//               </Col>
//             </Row>

//             <Divider />

//             <Title level={5}>Status Information</Title>
//             <Row gutter={[16, 16]}>
//               <Col xs={24} sm={8}>
//                 <Text strong>Payment:</Text>{' '}
//                 <Tag color={getPaymentStatusColor(selectedOrder.paymentStatus)}>
//                   {selectedOrder.paymentStatus}
//                 </Tag>
//               </Col>
//               <Col xs={24} sm={8}>
//                 <Text strong>Shipping:</Text>{' '}
//                 <Tag color={getShippingStatusColor(selectedOrder.shippingStatus)}>
//                   {selectedOrder.shippingStatus}
//                 </Tag>
//               </Col>
//             </Row>

//             <Divider />

//             <Title level={5}>Items</Title>
//             {selectedOrder.items?.map((item, index) => (
//               <Card key={index} size="small" style={{ marginBottom: 8 }}>
//                 <Row gutter={16}>
//                   <Col xs={24} sm={12}>
//                     <Text strong>{item.name}</Text>
//                   </Col>
//                   <Col xs={12} sm={6}>
//                     <Text>Qty: {item.quantity}</Text>
//                   </Col>
//                   <Col xs={12} sm={6}>
//                     <Text>AED {item.price}</Text>
//                   </Col>
//                 </Row>
//               </Card>
//             ))}

//             <Divider />

//             <Title level={5}>Shipping Information</Title>
//             <Row gutter={[16, 16]}>
//               <Col span={24}>
//                 <Text strong>Address:</Text>
//                 <div style={{ marginTop: 4 }}>
//                   <Text>{selectedOrder.shippingAddress?.fullName}</Text><br />
//                   <Text>{selectedOrder.shippingAddress?.address}</Text><br />
//                   <Text>
//                     {selectedOrder.shippingAddress?.city}, {selectedOrder.shippingAddress?.country}
//                   </Text><br />
//                   <Text>Phone: {selectedOrder.shippingAddress?.phone}</Text>
//                 </div>
//               </Col>
//             </Row>

//             {selectedOrder.trackingNumber && (
//               <Row gutter={16} style={{ marginTop: 16 }}>
//                 <Col span={24}>
//                   <Text strong>Tracking Number:</Text> {selectedOrder.trackingNumber}
//                 </Col>
//               </Row>
//             )}
//           </div>
//         )}
//       </Modal>

//       {/* Edit Order Drawer */}
//       <Drawer
//         title={`Edit Order - ${selectedOrder?.orderId}`}
//         placement="right"
//         onClose={() => {
//           setEditDrawerVisible(false);
//           form.resetFields();
//           setSelectedOrder(null);
//         }}
//         visible={editDrawerVisible}
//         width={isMobile ? '100%' : 500}
//       >
//         <Form form={form} layout="vertical" onFinish={handleUpdateOrder}>
//           <Form.Item name="paymentStatus" label="Payment Status" rules={[{ required: true }]}>
//             <Select placeholder="Select payment status">
//               <Option value="Pending">Pending</Option>
//               <Option value="Paid">Paid</Option>
//               <Option value="Failed">Failed</Option>
//               <Option value="Refunded">Refunded</Option>
//             </Select>
//           </Form.Item>

//           <Divider>Shipping Details</Divider>

//           <Form.Item name="shippingStatus" label="Shipping Status" rules={[{ required: true }]}>
//             <Select placeholder="Select shipping status">
//               <Option value="Not Shipped">Not Shipped</Option>
//               <Option value="Preparing">Preparing</Option>
//               <Option value="Shipped">Shipped</Option>
//               <Option value="In Transit">In Transit</Option>
//               <Option value="Delivered">Delivered</Option>
//             </Select>
//           </Form.Item>

//           <Form.Item name="trackingNumber" label="Tracking Number">
//             <Input placeholder="Enter tracking number" />
//           </Form.Item>

//           <Form.Item name="shippingAddress" label="Shipping Address" rules={[{ required: true }]}>
//             <TextArea rows={3} placeholder="Enter shipping address" />
//           </Form.Item>

//           <Form.Item>
//             <Space style={{ width: '100%' }} direction={isMobile ? 'vertical' : 'horizontal'}>
//               <Button
//                 type="primary"
//                 htmlType="submit"
//                 block={isMobile}
//                 loading={updateLoading}
//               >
//                 Update Order
//               </Button>
//               <Button
//                 onClick={() => {
//                   setEditDrawerVisible(false);
//                   form.resetFields();
//                   setSelectedOrder(null);
//                 }}
//                 block={isMobile}
//               >
//                 Cancel
//               </Button>
//             </Space>
//           </Form.Item>
//         </Form>
//       </Drawer>
//     </div>
//   );
// };

// export default OrdersSection;

import React, { useState, useEffect } from "react";
import {
  Layout,
  Menu,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Popconfirm,
  message,
  Row,
  Col,
  Statistic,
  Tag,
  Tabs,
  DatePicker,
  Upload,
  Switch,
  Divider,
  Badge,
  Typography,
  Drawer,
  List,
  Avatar,
  Grid,
} from "antd";
import {
  ShoppingCartOutlined,
  AppstoreOutlined,
  TagsOutlined,
  GiftOutlined,
  DashboardOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  UploadOutlined,
  DollarOutlined,
  ShoppingOutlined,
  UserOutlined,
  BarChartOutlined,
  PhoneOutlined,
  MailOutlined,
  CalendarOutlined,
  HomeOutlined,
  SearchOutlined,
  ClearOutlined,
  FilterOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import { orderService } from "../services";
import { useApiEnhanced } from "../hooks/useApiEnhanced";
import { toast } from "react-toastify";

const { Header, Sider, Content } = Layout;
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { useBreakpoint } = Grid;

const OrdersSection = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const isTablet = screens.md && !screens.lg;

  // Search filters state
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilters, setStatusFilters] = useState({
    paymentStatus: "",
    shippingStatus: "",
  });
  const [filteredOrders, setFilteredOrders] = useState([]);

  const {
    data: orders,
    loading: ordersLoading,
    execute: refetchOrder,
  } = useApiEnhanced(() => orderService.getOrders({ page: 1, limit: 100 }), {
    immediate: true,
  });

  const { loading: updateLoading, execute: updateOrder } = useApiEnhanced(
    (id, data) => orderService.updateOrder(id, data),
    { immediate: false }
  );

  console.log(orders, "ordersList");

  const [editDrawerVisible, setEditDrawerVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [form] = Form.useForm();

  // Filter orders based on search criteria
  useEffect(() => {
    if (!orders?.data) {
      setFilteredOrders([]);
      return;
    }

    let filtered = orders.data.filter((order) => {
      const customerName = order.customer?.name?.toLowerCase() || "";
      const email = order.customer?.email?.toLowerCase() || "";
      const orderId = order.orderId?.toLowerCase() || "";
      const searchLower = searchTerm.toLowerCase();

      const matchesSearch =
        searchTerm === "" ||
        customerName.includes(searchLower) ||
        email.includes(searchLower) ||
        orderId.includes(searchLower);

      const matchesPaymentStatus =
        statusFilters.paymentStatus === "" ||
        order.paymentStatus === statusFilters.paymentStatus;
      const matchesShippingStatus =
        statusFilters.shippingStatus === "" ||
        order.shippingStatus === statusFilters.shippingStatus;

      return matchesSearch && matchesPaymentStatus && matchesShippingStatus;
    });

    setFilteredOrders(filtered);
  }, [orders?.data, searchTerm, statusFilters]);

  const handleSearchChange = (value) => {
    setSearchTerm(value);
  };

  const handleStatusFilterChange = (key, value) => {
    setStatusFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const clearAllFilters = () => {
    setSearchTerm("");
    setStatusFilters({
      paymentStatus: "",
      shippingStatus: "",
    });
  };

  const hasActiveFilters =
    searchTerm !== "" ||
    Object.values(statusFilters).some((filter) => filter !== "");

  // Print Invoice Function
  const handlePrint = (order) => {
    const printWindow = window.open("", "_blank");
    const invoiceHTML = generateInvoiceHTML(order);

    printWindow.document.write(invoiceHTML);
    printWindow.document.close();

    printWindow.onload = function () {
      printWindow.focus();
      printWindow.print();
    };
  };

  const generateInvoiceHTML = (order) => {
    console.log("Order data for invoice:", order); // Debug log

    const subtotal =
      order.items?.reduce((sum, item) => sum + item.price * item.quantity, 0) ||
      0;
    const discount = order.discount || 0;
    const shippingCost = order.shippingCost || 0;
    const tax = order.tax || 0;

    // Handle customer data - could be nested or direct
    const customerName = order.customer?.name || order.customerName || "N/A";
    const customerEmail = order.customer?.email || order.customerEmail || "N/A";
    const customerPhone = order.customer?.phone || order.customerPhone || "N/A";

    // Handle shipping address
    const shippingName =
      order.shippingAddress?.fullName ||
      order.shippingAddress?.name ||
      customerName;
    const shippingAddr =
      order.shippingAddress?.address || order.shippingAddress?.street || "N/A";
    const shippingCity = order.shippingAddress?.city || "N/A";
    const shippingCountry = order.shippingAddress?.country || "N/A";
    const shippingPhone = order.shippingAddress?.phone || customerPhone;

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Invoice - ${order.orderId}</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: 'Arial', sans-serif;
            padding: 40px;
            color: #333;
            line-height: 1.6;
          }
          
          .invoice-container {
            max-width: 800px;
            margin: 0 auto;
            background: white;
          }
          
          .invoice-header {
            display: flex;
            justify-content: space-between;
            align-items: start;
            margin-bottom: 40px;
            padding-bottom: 20px;
            border-bottom: 3px solid #1890ff;
          }
          
          .company-info h1 {
            color: #1890ff;
            font-size: 32px;
            margin-bottom: 5px;
          }
          
          .company-info p {
            color: #666;
            font-size: 14px;
          }
          
          .invoice-title {
            text-align: right;
          }
          
          .invoice-title h2 {
            font-size: 36px;
            color: #1890ff;
            margin-bottom: 10px;
          }
          
          .invoice-meta {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-bottom: 40px;
          }
          
          .info-block {
            background: #f9f9f9;
            padding: 20px;
            border-radius: 8px;
          }
          
          .info-block h3 {
            color: #1890ff;
            margin-bottom: 15px;
            font-size: 16px;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          
          .info-block p {
            margin-bottom: 8px;
            font-size: 14px;
          }
          
          .info-block strong {
            display: inline-block;
            width: 120px;
            color: #666;
          }
          
          .items-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 30px;
          }
          
          .items-table thead {
            background: #1890ff;
            color: white;
          }
          
          .items-table th {
            padding: 15px;
            text-align: left;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 12px;
            letter-spacing: 0.5px;
          }
          
          .items-table td {
            padding: 15px;
            border-bottom: 1px solid #eee;
          }
          
          .items-table tbody tr:hover {
            background: #f9f9f9;
          }
          
          .text-right {
            text-align: right;
          }
          
          .text-center {
            text-align: center;
          }
          
          .totals-section {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 40px;
          }
          
          .totals-table {
            width: 350px;
          }
          
          .totals-row {
            display: flex;
            justify-content: space-between;
            padding: 10px 0;
            border-bottom: 1px solid #eee;
          }
          
          .totals-row.final {
            background: #1890ff;
            color: white;
            padding: 15px;
            margin-top: 10px;
            border-radius: 8px;
            font-size: 20px;
            font-weight: bold;
          }
          
          .footer {
            margin-top: 60px;
            padding-top: 20px;
            border-top: 2px solid #eee;
            text-align: center;
            color: #666;
            font-size: 12px;
          }
          
          .status-badge {
            display: inline-block;
            padding: 5px 15px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: bold;
            margin-top: 5px;
          }
          
          .status-paid {
            background: #52c41a;
            color: white;
          }
          
          .status-pending {
            background: #faad14;
            color: white;
          }
          
          .status-delivered {
            background: #52c41a;
            color: white;
          }
          
          .status-shipped {
            background: #1890ff;
            color: white;
          }
          
          @media print {
            body {
              padding: 20px;
            }
            
            .invoice-container {
              max-width: 100%;
            }
          }
        </style>
      </head>
      <body>
        <div class="invoice-container">
          <div class="invoice-header">
            <div class="company-info">
              <h1>Your Company Name</h1>
              <p>123 Business Street</p>
              <p>City, Country - 12345</p>
              <p>Phone: +971 XX XXX XXXX</p>
              <p>Email: info@yourcompany.com</p>
            </div>
            <div class="invoice-title">
              <h2>INVOICE</h2>
              <p style="font-size: 14px; color: #666;">Order #${
                order.orderId
              }</p>
              <p style="font-size: 14px; color: #666;">Date: ${new Date(
                order.createdAt
              ).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}</p>
            </div>
          </div>
          
          <div class="invoice-meta">
            <div class="info-block">
              <h3>Bill To</h3>
              <p><strong>Customer:</strong> ${customerName}</p>
              <p><strong>Email:</strong> ${customerEmail}</p>
              <p><strong>Phone:</strong> ${customerPhone}</p>
            </div>
            
            <div class="info-block">
              <h3>Ship To</h3>
              <p><strong>Name:</strong> ${shippingName}</p>
              <p><strong>Address:</strong> ${shippingAddr}</p>
              <p><strong>City:</strong> ${shippingCity}</p>
              <p><strong>Country:</strong> ${shippingCountry}</p>
              <p><strong>Phone:</strong> ${shippingPhone}</p>
              ${
                order.trackingNumber
                  ? `<p><strong>Tracking:</strong> ${order.trackingNumber}</p>`
                  : ""
              }
            </div>
          </div>
          
          <div style="margin-bottom: 20px;">
            <span class="status-badge status-${order.paymentStatus?.toLowerCase()}">${
      order.paymentStatus
    }</span>
            <span class="status-badge status-${order.shippingStatus
              ?.toLowerCase()
              .replace(" ", "-")}">${order.shippingStatus}</span>
          </div>
          
          <table class="items-table">
            <thead>
              <tr>
                <th style="width: 50px;">#</th>
                <th>Product</th>
                <th class="text-center" style="width: 100px;">Quantity</th>
                <th class="text-right" style="width: 120px;">Unit Price</th>
                <th class="text-right" style="width: 120px;">Total</th>
              </tr>
            </thead>
            <tbody>
              ${
                order.items
                  ?.map(
                    (item, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>
                    <strong>${
                      item.name ||
                      item.productName ||
                      item.product?.name ||
                      "N/A"
                    }</strong>
                    ${
                      item.sku || item.product?.sku
                        ? `<br><small style="color: #666;">SKU: ${
                            item.sku || item.product?.sku
                          }</small>`
                        : ""
                    }
                  </td>
                  <td class="text-center">${item.quantity || 1}</td>
                  <td class="text-right">AED ${(
                    item.price ||
                    item.unitPrice ||
                    0
                  ).toFixed(2)}</td>
                  <td class="text-right"><strong>AED ${(
                    (item.price || item.unitPrice || 0) * (item.quantity || 1)
                  ).toFixed(2)}</strong></td>
                </tr>
              `
                  )
                  .join("") ||
                '<tr><td colspan="5" class="text-center">No items</td></tr>'
              }
            </tbody>
          </table>
          
          <div class="totals-section">
            <div class="totals-table">
              <div class="totals-row">
                <span>Subtotal:</span>
                <span>AED ${subtotal.toFixed(2)}</span>
              </div>
              ${
                discount > 0
                  ? `
              <div class="totals-row">
                <span>Discount:</span>
                <span>- AED ${discount.toFixed(2)}</span>
              </div>
              `
                  : ""
              }
              ${
                shippingCost > 0
                  ? `
              <div class="totals-row">
                <span>Shipping:</span>
                <span>AED ${shippingCost.toFixed(2)}</span>
              </div>
              `
                  : ""
              }
              ${
                tax > 0
                  ? `
              <div class="totals-row">
                <span>Tax:</span>
                <span>AED ${tax.toFixed(2)}</span>
              </div>
              `
                  : ""
              }
              <div class="totals-row final">
                <span>TOTAL:</span>
                <span>AED ${order.finalAmount?.toFixed(2) || "0.00"}</span>
              </div>
            </div>
          </div>
          
          <div class="info-block" style="margin-bottom: 20px;">
            <h3>Payment Information</h3>
            <p><strong>Payment Method:</strong> ${
              order.paymentMethod || "N/A"
            }</p>
            <p><strong>Payment Status:</strong> ${order.paymentStatus}</p>
          </div>
          
          <div class="footer">
            <p><strong>Thank you for your business!</strong></p>
            <p style="margin-top: 10px;">For any questions about this invoice, please contact us at info@yourcompany.com</p>
            <p style="margin-top: 15px; font-size: 11px;">This is a computer-generated invoice and does not require a signature.</p>
          </div>
        </div>
      </body>
      </html>
    `;
  };

  // Desktop/Tablet columns
  const getColumns = () => {
    const baseColumns = [
      {
        title: "Order ID",
        dataIndex: "_id",
        key: "_id",
        width: 120,
        fixed: "left",
        render: (order) => `ODR_${order}`,
      },
      {
        title: "Customer",
        dataIndex: ["user", "name"],
        key: "customer",
        width: 120,
      },
      {
        title: "Amount",
        dataIndex: "totalAmount",
        key: "amount",
        width: 100,
        render: (amount) => `${amount?.toFixed(2) || "0.00"}`,
      },
      {
        title: "Date",
        dataIndex: "createdAt",
        key: "date",
        width: 120,
        render: (date) =>
          new Date(date).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          }),
      },
      {
        title: "Actions",
        key: "actions",
        width: 150,
        fixed: "right",
        render: (_, record) => (
          <Space size="small">
            <Button
              icon={<EyeOutlined />}
              onClick={() => handleView(record)}
              size="small"
              type="text"
              title="View Details"
            />
            <Button
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
              size="small"
              type="text"
              title="Edit Order"
            />
            <Button
              icon={<PrinterOutlined />}
              onClick={() => handlePrint(record)}
              size="small"
              type="text"
              title="Print Invoice"
            />
          </Space>
        ),
      },
    ];

    if (!isMobile) {
      baseColumns.splice(2, 0, {
        title: "Email",
        dataIndex: ["user", "email"],
        key: "email",
        width: 200,
      });

      baseColumns.splice(3, 0, {
        title: "Phone",
        dataIndex: ["user", "mobile"],
        key: "phone",
        width: 120,
      });

      if (!isTablet) {
        baseColumns.splice(5, 0, {
          title: "Payment Method",
          dataIndex: "paymentMethod",
          key: "paymentMethod",
          width: 120,
        });

        baseColumns.splice(7, 0, {
          title: "Payment Status",
          dataIndex: "paymentStatus",
          key: "paymentStatus",
          width: 120,
          render: (status) => {
            const colors = {
              Pending: "orange",
              Paid: "green",
              Failed: "red",
              Refunded: "purple",
            };
            return <Tag color={colors[status]}>{status}</Tag>;
          },
        });

        baseColumns.splice(8, 0, {
          title: "Shipping Status",
          dataIndex: "orderStatus",
          key: "orderStatus",
          width: 120,
          render: (status) => {
            const colors = {
              "Not Shipped": "default",
              Preparing: "orange",
              Shipped: "blue",
              "In Transit": "cyan",
              Delivered: "green",
            };
            return <Tag color={colors[status]}>{status}</Tag>;
          },
        });
      }
    }

    return baseColumns;
  };

  // Mobile card view
  const OrderCard = ({ order }) => (
    <Card
      size="small"
      style={{ marginBottom: 12 }}
      actions={[
        <Button
          type="text"
          icon={<EyeOutlined />}
          onClick={() => handleView(order)}
          size="small"
        >
          View
        </Button>,
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={() => handleEdit(order)}
          size="small"
        >
          Edit
        </Button>,
        <Button
          type="text"
          icon={<PrinterOutlined />}
          onClick={() => handlePrint(order)}
          size="small"
        >
          Print
        </Button>,
      ]}
    >
      <div style={{ marginBottom: 8 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 8,
          }}
        >
          <Text strong style={{ fontSize: 16 }}>
            {order.orderId}
          </Text>
          <Text strong style={{ color: "#1890ff", fontSize: 16 }}>
            AED {order.finalAmount?.toFixed(2) || "0.00"}
          </Text>
        </div>

        <div style={{ marginBottom: 6 }}>
          <UserOutlined style={{ marginRight: 6, color: "#666" }} />
          <Text>{order.customer?.name}</Text>
        </div>

        <div style={{ marginBottom: 6 }}>
          <MailOutlined style={{ marginRight: 6, color: "#666" }} />
          <Text style={{ fontSize: 12 }}>{order.customer?.email}</Text>
        </div>

        <div style={{ marginBottom: 6 }}>
          <PhoneOutlined style={{ marginRight: 6, color: "#666" }} />
          <Text>{order.customer?.phone}</Text>
        </div>

        <div style={{ marginBottom: 8 }}>
          <CalendarOutlined style={{ marginRight: 6, color: "#666" }} />
          <Text style={{ fontSize: 12 }}>
            {new Date(order.createdAt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
          </Text>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
          <Tag color={getPaymentStatusColor(order.paymentStatus)}>
            {order.paymentStatus}
          </Tag>
          <Tag color={getShippingStatusColor(order.shippingStatus)}>
            {order.shippingStatus}
          </Tag>
        </div>
      </div>
    </Card>
  );

  const getPaymentStatusColor = (status) => {
    const colors = {
      Pending: "orange",
      Paid: "green",
      Failed: "red",
      Refunded: "purple",
    };
    return colors[status] || "default";
  };

  const getShippingStatusColor = (status) => {
    const colors = {
      "Not Shipped": "default",
      Preparing: "orange",
      Shipped: "blue",
      "In Transit": "cyan",
      Delivered: "green",
    };
    return colors[status] || "default";
  };

  const handleView = (order) => {
    setSelectedOrder(order);
    setViewModalVisible(true);
  };

  const handleEdit = (order) => {
    setSelectedOrder(order);
    form.setFieldsValue({
      status: order.status,
      paymentStatus: order.paymentStatus,
      shippingStatus: order.shippingStatus,
      trackingNumber: order.trackingNumber,
      shippingAddress: `${order.shippingAddress?.address || ""}, ${
        order.shippingAddress?.city || ""
      }, ${order.shippingAddress?.country || ""}`,
    });
    setEditDrawerVisible(true);
  };

  const handleUpdateOrder = async (values) => {
    try {
      let res = await updateOrder(selectedOrder?._id, values);
      if (!res?.success)
        return toast.error(res?.message || "something went wrong!");
      toast.success(res?.message || "updated successfully!");
      refetchOrder();
      setEditDrawerVisible(false);
      form.resetFields();
      setSelectedOrder(null);
    } catch (error) {
      return toast.error("Something went wrong!");
    }
  };

  return (
    <div style={{ padding: isMobile ? "12px" : "24px" }}>
      <Title level={isMobile ? 4 : 3} style={{ marginBottom: 16 }}>
        Orders Management
      </Title>

      {/* Search and Filters */}
      <Card
        size="small"
        style={{ marginBottom: 16 }}
        title={
          <Space>
            <FilterOutlined />
            <Text strong>Search & Filters</Text>
            {hasActiveFilters && <Badge count={1} />}
          </Space>
        }
        extra={
          hasActiveFilters && (
            <Button
              size="small"
              icon={<ClearOutlined />}
              onClick={clearAllFilters}
              type="text"
            >
              Clear All
            </Button>
          )
        }
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Input
              placeholder="Search by Customer Name, Email, or Order ID"
              prefix={<SearchOutlined />}
              value={searchTerm}
              onChange={(e) => handleSearchChange(e.target.value)}
              allowClear
              size="default"
            />
          </Col>

          <Col xs={24} sm={12} md={6} lg={6}>
            <Select
              placeholder="Shipping Status"
              value={statusFilters.shippingStatus}
              onChange={(value) =>
                handleStatusFilterChange("shippingStatus", value)
              }
              allowClear
              style={{ width: "100%" }}
              size="default"
            >
              <Option value="Not Shipped">Not Shipped</Option>
              <Option value="Preparing">Preparing</Option>
              <Option value="Shipped">Shipped</Option>
              <Option value="In Transit">In Transit</Option>
              <Option value="Delivered">Delivered</Option>
            </Select>
          </Col>
        </Row>

        {hasActiveFilters && (
          <div
            style={{
              marginTop: 12,
              paddingTop: 12,
              borderTop: "1px solid #f0f0f0",
            }}
          >
            <Text type="secondary" style={{ fontSize: 12 }}>
              Showing {filteredOrders.length} of {orders?.data?.length || 0}{" "}
              orders
              {searchTerm && <span> • Searching for: "{searchTerm}"</span>}
            </Text>
          </div>
        )}
      </Card>

      {isMobile ? (
        <div>
          {ordersLoading ? (
            <div style={{ textAlign: "center", padding: 20 }}>
              <Text>Loading orders...</Text>
            </div>
          ) : filteredOrders.length === 0 ? (
            <Card style={{ textAlign: "center", padding: 20 }}>
              <Text type="secondary">
                {hasActiveFilters
                  ? "No orders match your search criteria"
                  : "No orders found"}
              </Text>
            </Card>
          ) : (
            filteredOrders.map((order, index) => (
              <OrderCard key={order._id || index} order={order} />
            ))
          )}
        </div>
      ) : (
        <Table
          columns={getColumns()}
          dataSource={filteredOrders}
          loading={ordersLoading}
          scroll={{ x: "max-content" }}
          pagination={{
            responsive: true,
            showSizeChanger: true,
            showQuickJumper: !isTablet,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} orders${
                hasActiveFilters ? " (filtered)" : ""
              }`,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          size={isTablet ? "small" : "middle"}
          locale={{
            emptyText: hasActiveFilters
              ? "No orders match your search criteria"
              : "No orders found",
          }}
        />
      )}

      {/* View Order Modal */}
      <Modal
        title={`Order Details - ${selectedOrder?.orderId}`}
        visible={viewModalVisible}
        onCancel={() => {
          setViewModalVisible(false);
          setSelectedOrder(null);
        }}
        footer={[
          <Button
            key="print"
            type="primary"
            icon={<PrinterOutlined />}
            onClick={() => handlePrint(selectedOrder)}
          >
            Print Invoice
          </Button>,
          <Button
            key="close"
            onClick={() => {
              setViewModalVisible(false);
              setSelectedOrder(null);
            }}
          >
            Close
          </Button>,
        ]}
        width={isMobile ? "95%" : 700}
        style={isMobile ? { top: 20 } : {}}
      >
        {selectedOrder && (
          <div>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12}>
                <Text strong>Customer:</Text> {selectedOrder.customer?.name}
              </Col>
              <Col xs={24} sm={12}>
                <Text strong>Email:</Text> {selectedOrder.customer?.email}
              </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
              <Col xs={24} sm={12}>
                <Text strong>Phone:</Text> {selectedOrder.customer?.phone}
              </Col>
              <Col xs={24} sm={12}>
                <Text strong>Payment Method:</Text>{" "}
                {selectedOrder.paymentMethod}
              </Col>
            </Row>

            <Divider />

            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12}>
                <Text strong>Order Date:</Text>{" "}
                {new Date(selectedOrder.createdAt).toLocaleDateString()}
              </Col>
              <Col xs={24} sm={12}>
                <Text strong>Total Amount:</Text> AED{" "}
                {selectedOrder.finalAmount?.toFixed(2)}
              </Col>
            </Row>

            <Divider />

            <Title level={5}>Status Information</Title>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={8}>
                <Text strong>Payment:</Text>{" "}
                <Tag color={getPaymentStatusColor(selectedOrder.paymentStatus)}>
                  {selectedOrder.paymentStatus}
                </Tag>
              </Col>
              <Col xs={24} sm={8}>
                <Text strong>Shipping:</Text>{" "}
                <Tag
                  color={getShippingStatusColor(selectedOrder.shippingStatus)}
                >
                  {selectedOrder.shippingStatus}
                </Tag>
              </Col>
            </Row>

            <Divider />

            <Title level={5}>Items</Title>
            {selectedOrder.items?.map((item, index) => (
              <Card key={index} size="small" style={{ marginBottom: 8 }}>
                <Row gutter={16}>
                  <Col xs={24} sm={12}>
                    <Text strong>{item.name}</Text>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Text>Qty: {item.quantity}</Text>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Text>AED {item.price}</Text>
                  </Col>
                </Row>
              </Card>
            ))}

            <Divider />

            <Title level={5}>Shipping Information</Title>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Text strong>Address:</Text>
                <div style={{ marginTop: 4 }}>
                  <Text>{selectedOrder.shippingAddress?.fullName}</Text>
                  <br />
                  <Text>{selectedOrder.shippingAddress?.address}</Text>
                  <br />
                  <Text>
                    {selectedOrder.shippingAddress?.city},{" "}
                    {selectedOrder.shippingAddress?.country}
                  </Text>
                  <br />
                  <Text>Phone: {selectedOrder.shippingAddress?.phone}</Text>
                </div>
              </Col>
            </Row>

            {selectedOrder.trackingNumber && (
              <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={24}>
                  <Text strong>Tracking Number:</Text>{" "}
                  {selectedOrder.trackingNumber}
                </Col>
              </Row>
            )}
          </div>
        )}
      </Modal>

      {/* Edit Order Drawer */}
      <Drawer
        title={`Edit Order - ${selectedOrder?.orderId}`}
        placement="right"
        onClose={() => {
          setEditDrawerVisible(false);
          form.resetFields();
          setSelectedOrder(null);
        }}
        visible={editDrawerVisible}
        width={isMobile ? "100%" : 500}
      >
        <Form form={form} layout="vertical" onFinish={handleUpdateOrder}>
          <Form.Item
            name="paymentStatus"
            label="Payment Status"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select payment status">
              <Option value="Pending">Pending</Option>
              <Option value="Paid">Paid</Option>
              <Option value="Failed">Failed</Option>
              <Option value="Refunded">Refunded</Option>
            </Select>
          </Form.Item>

          <Divider>Shipping Details</Divider>

          <Form.Item
            name="orderStatus"
            label="Shipping Status"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select shipping status">
              <Option value="Not Shipped">Not Shipped</Option>
              <Option value="Preparing">Preparing</Option>
              <Option value="Shipped">Shipped</Option>
              <Option value="In Transit">In Transit</Option>
              <Option value="Delivered">Delivered</Option>
            </Select>
          </Form.Item>

          <Form.Item name="trackingNumber" label="Tracking Number">
            <Input placeholder="Enter tracking number" />
          </Form.Item>

          <Form.Item
            name="shippingAddress"
            label="Shipping Address"
            rules={[{ required: true }]}
          >
            <TextArea rows={3} placeholder="Enter shipping address" />
          </Form.Item>

          <Form.Item>
            <Space
              style={{ width: "100%" }}
              direction={isMobile ? "vertical" : "horizontal"}
            >
              <Button
                type="primary"
                htmlType="submit"
                block={isMobile}
                loading={updateLoading}
              >
                Update Order
              </Button>
              <Button
                onClick={() => {
                  setEditDrawerVisible(false);
                  form.resetFields();
                  setSelectedOrder(null);
                }}
                block={isMobile}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};

export default OrdersSection;
